import { MobileCarouselController, type MobileCarouselControllerOptions } from './MobileCarouselController';

const selectors = {
    carousel: '.sgw-mobile-carousel:not(.expEditor)',
} as const;

let activeControllers: MobileCarouselController[] = [];

export const initMobileCarousels = (options: MobileCarouselControllerOptions = {}): MobileCarouselController[] => {
    const elements = Array.from(document.querySelectorAll<HTMLElement>(selectors.carousel));

    const controllers = elements.map((element) => new MobileCarouselController(element, options));
    activeControllers = controllers;

    return controllers;
};

export const destroyMobileCarousels = (): void => {
    activeControllers.forEach((controller) => controller.destroy());
    activeControllers = [];
};

const executeMobileCarousels = (): void => {
    if (document.readyState === 'loading') {
        document.addEventListener(
            'DOMContentLoaded',
            () => {
                initMobileCarousels();
            },
            { once: true },
        );
        return;
    }

    initMobileCarousels();
};

export default executeMobileCarousels;
export { MobileCarouselController };
export type { MobileCarouselControllerOptions };
